import React from 'react';
import { useTranslation } from './useTranslation';

/**
 * Higher-Order Component to inject translation functions into class components
 * Usage: export default withTranslation(MyClassComponent);
 *
 * Provides props:
 * - t(path, defaultValue) - get translated string
 * - language - current language code
 * - getShared(path, defaultValue) - get shared config value
 * - branding, images, links - shared config sections
 */
export function withTranslation(WrappedComponent) {
    return function WithTranslationWrapper(props) {
        const translationProps = useTranslation();
        return <WrappedComponent {...props} {...translationProps} />;
    };
}

export default withTranslation;
